export function titleSelectorFnMaker(courseId) {
    return session => {
        const course = session.Course.withId(String(courseId));
        if (course === null) {
            return null;
        }
        return course.title;
    }
}

export function topicsSelectorFnMaker(ids) {
    return session => {
        let result = ids.map(topicId => {
            const topic = session.Topic.withId(topicId);
            return topic.ref;
        })
        result = result.map((t) => {
            return Object.assign({}, t);
        });
        return result
    }
}

export function discussionsListSelectorFnMaker(discussionListId) {
    return session => {
        return discussionListId.map((discussionId) => {
            const discussionModel = session.Discussion.withId(discussionId);
            const newDiscussion = {
                id: discussionModel.id,
                topicId: discussionModel.topic && discussionModel.topic.id,
                title: discussionModel.title,
                users: [{
                    id: discussionModel.creator.id,
                    fullName: discussionModel.creator.fullName,
                    image: discussionModel.creator.image,
                    role: discussionModel.creator.role
                }],
                lastActivity: discussionModel.createAt,
                replies: discussionModel.postCount,
                views: 1,
            }
            return Object.assign({}, newDiscussion);
        });
    }
}

export function discussionSelectorFnMaker(discussionId) {
    return session => {
        const discussionModel = session.Discussion.withId(discussionId);
        if (!discussionModel) {
            return null;
        }
        const posts = discussionModel.posts.toModelArray().map(post => {
            let user;
            if (post.user) {
                user = {
                    id: post.user.id,
                    image: post.user.image,
                    fullName: post.user.fullName,
                    role: post.user.role
                }
            }
            let attachments = [];
            if (post.attachments) {
                attachments = post.attachments.toRefArray().map(attachment => {
                    return Object.assign({}, attachment);
                })
            }

            let mentionedStudents = [];
            if (post.mentionedStudents.length != 0) {
                mentionedStudents = post.mentionedStudents.map(mentionedStudent => {
                    return Object.assign({}, mentionedStudent);
                })
            }

            const result = {
                id: post.id,
                user: Object.assign({}, user),
                content: post.content,
                sendDate: post.sendDate,
                isLiked: post.isLiked,
                likes: post.likes,
                reply: post.reply && Object.assign({}, post.reply.ref),
                attachments,
                mentionedStudents
            }
            return Object.assign({}, result);
        });
        const creator = {
            id: discussionModel.creator.id,
            image: discussionModel.creator.image,
            fullName: discussionModel.creator.fullName,
            role: discussionModel.creator.role
        }
        const result = {
            id: discussionModel.id,
            topicId: discussionModel.topic && discussionModel.topic.id,
            creator: Object.assign({}, creator),
            title: discussionModel.title,
            content: discussionModel.content,
            createAt: discussionModel.createAt,
            posts: posts || []
        }
        return Object.assign({}, result);
    }
}

export function courseSelectorFnMaker(courseId) {
    return session => {
        const course = session.Course.withId(String(courseId));
        if (course === null) {
            return null;
        }
        return Object.assign({}, course.ref, {
            teachers: course.teachers.toRefArray().map(teacher => Object.assign({}, teacher)),
            chapters: course.chapters.toModelArray().map(chapter => 
                (Object.assign({}, chapter.ref, {
                    sections: chapter.sections.toModelArray().map(section => (
                        Object.assign({}, section.ref, {
                            units: section.units.toRefArray().map(unit => Object.assign({}, unit)),
                        })
                    ))
                })
            )),
        });
    }
}

export function attachmentsSelectorFnMaker() {
    return session => {
        const attachments = session.ForumAttachment.all().filter({
            post: null,
        }).toRefArray().map(attachmentRef => {
            return Object.assign({}, attachmentRef);
        });
        return attachments;
    }
}

export function postAttachmentsSelectorFnMaker(postId) {
    return session => {
        return session.Post.withId(postId).attachments.all().toRefArray().map(ar => (Object.assign({}, ar)));
    }
}

export function getFirstDiscussionOfTopic(topicId) {
    return session => {
        const topic = session.Topic.withId(topicId)
        if (topic && topic.discussions.exists()) {
            return topic.discussions.first().ref;
        } else {
            return null;
        }
    }
}